import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { API } from "../../../services/axios";
import { URLS } from "../../../services/urls";
import { useParams } from "react-router-dom";

const AdminManage = ({ toEdit, onSuccess }) => {
  const { register, reset, handleSubmit } = useForm({
    defaultValues: toEdit || {}, // Par défaut, charge les valeurs de `toEdit`
  });
  const { t } = useTranslation();
  const { auth } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (toEdit) {
      reset(toEdit); // Réinitialiser le formulaire avec les nouvelles données quand `toEdit` change
    }
  }, [toEdit, reset]);

  const onSubmit = (data) => {
    console.log('Auth state:', auth);
    
    if (!data.last_name) {
      toast.error("Last name is required.");
      return;
    }

    if (!auth?.id) {
      toast.error("User ID is not defined.");
      return;
    }

    let formData = new FormData();
    formData.append("first_name", data.first_name);
    formData.append("last_name", data.last_name);
    formData.append("email", data.email);
    formData.append("service", data.service);
    formData.append("role", data.role);
    formData.append("created_by", auth.id);

    setLoading(true);

    const apiCall = toEdit?.id
      ? API.put(URLS.USERS.update(toEdit.id), formData)
      : API.post(URLS.USERS.create, formData);

    apiCall
      .then((resp) => {
        toast.success(
          toEdit
            ? t("textAdminEditionSuccess")
            : t("textUserCreatedSuccess")
        );
        setLoading(false);
        onSuccess();
        reset();
        window.$("#manageIndustryForm").modal("hide");
      })
      .catch((error) => {
        console.log(error);
        toast.error(
          error?.response?.data?.detail ??
            error?.response?.data?.message ??
            t("textAdminEditionError")
        );
        setLoading(false);
      });
  };

  return (
    <div
      className="modal fade"
      id="manageIndustryForm"
      tabIndex={-1}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content apply-job-form">
          <button
            className="btn-close"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div className="modal-body pl-30 pr-30 pt-50">
            <div className="text-center">
              <p className="font-sm text-brand-2">
                {toEdit ? t("Modifier") : t("Créer")}
              </p>
            </div>
            <form
              className="login-register text-start mt-20 pb-30"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="form-group">
                <label className="form-label" htmlFor="input-1">
                  {t("Prénom")} *
                </label>
                <input
                  className="form-control"
                  id="input-1"
                  type="text"
                  {...register("first_name", { required: true })}
                  placeholder="Steven"
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="input-2">
                  {t("Nom")} *
                </label>
                <input
                  className="form-control"
                  id="input-2"
                  type="text"
                  {...register("last_name", { required: true })}
                  placeholder={t("Job")}
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="input-3">
                  {t("Email")} *
                </label>
                <input
                  className="form-control"
                  id="input-3"
                  type="email"
                  {...register("email", { required: true })}
                  placeholder="Job@gmail.com"
                />
                <div className="form-group">
                <label className="form-label" htmlFor="role">
                  {t("Service")}
                </label>
                <select
                  className="form-control"
                  {...register("service")}
                  placeholder={t("textRole")}
                >
                  <option value="">{t("choose service")}</option>
                  <option value="commercial">{t("Commercial")}</option>
                  <option value="marketing">{t("Marketing")}</option>
                  <option value="comptabilite">{t("Comptabilite")}</option>
                  <option value="informatique">{t("Informatique")}</option>
                  <option value="administration">{t("Administration")}</option>
                </select>
              </div>
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="role">
                  {t("Role")}
                </label>
                <select
                  className="form-control"
                  {...register("role")}
                  placeholder={t("textRole")}
                >
                  <option value="">{t("choose role")}</option>
                  <option value="employee">{t("Employee")}</option>
                  <option value="manager">{t("Manager")}</option>
                  <option value="admin">{t("Admin")}</option>
                </select>
              </div>

              <div className="form-group">
                <button
                  className="btn btn-default hover-up w-100"
                  type="submit"
                  name="login"
                >
                  {t("Soumettre")}
                  {loading && (
                    <div
                      className="spinner-border ml-10 spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminManage;
